document.addEventListener('DOMContentLoaded', function () {
    var collapsibleButtons = document.querySelectorAll('.collapsible__button');

    collapsibleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var parentcollapsible = this.closest('.collapsible');
            var innerContent = parentcollapsible.querySelector('.collapsible__inner');

            // Close all collapsibles except the clicked one
            var allCollapsibles = document.querySelectorAll('.collapsible');
            allCollapsibles.forEach(function (collapsible) {
                var collapsibleButton = collapsible.querySelector('.collapsible__button');
                var collapsibleInnerContent = collapsible.querySelector('.collapsible__inner');

                if (collapsible !== parentcollapsible) {
                    collapsibleButton.setAttribute('aria-expanded', 'false');
                    collapsibleInnerContent.style.height = '0px';
                }
            });

            if (this.getAttribute('aria-expanded') === 'false') {
                // Expand the clicked collapsible
                this.setAttribute('aria-expanded', 'true');
                innerContent.style.height = innerContent.scrollHeight + 'px';
            } else {
                // Collapse the clicked collapsible
                this.setAttribute('aria-expanded', 'false');
                innerContent.style.height = '0px';
            }
        });
    });
});
